// @ts-strict-ignore
import type { JourneyApplicationStateTypes } from '@usealloy/typegen';
import { JourneyApplicationStateTypesMap } from '@usealloy/typegen';

import type { NodeData } from '~/journey/types.d';

import apiCalls from '../../helpers/apiCalls';

const {
  workflows: { getWorkflowDetails },
} = apiCalls;

export const getEOJReconWfNodeOutcomes = async ({
  eojReconNode,
  isReconWorkflowInGraphEnabled,
  journeyApplicationState,
}: {
  eojReconNode?: NodeData;
  isReconWorkflowInGraphEnabled: boolean;
  journeyApplicationState: JourneyApplicationStateTypes;
}) => {
  if (
    isReconWorkflowInGraphEnabled
    && eojReconNode?.config?.workflow_token
    && journeyApplicationState === JourneyApplicationStateTypesMap
      .PENDING_JOURNEY_APPLICATION_REVIEW
  ) {
    const {
      config: {
        workflow_token: workflowToken,
        workflow_current_version: workflowCurrentVersion,
      },
    } = eojReconNode;

    const workflowVersionsData = await getWorkflowDetails(workflowToken);
    const workflowVersions = workflowVersionsData?.tableState?.data?.[0]?.data ?? [];
    const workflowVersion = workflowVersions?.find(
      version => version.public_version === workflowCurrentVersion,
    );

    return workflowVersion?.outcomes ?? [];
  }

  return [];
};
